import { createAsyncThunk } from '@reduxjs/toolkit';
import { baseUrl } from '../../constants/Endpoints/EndPoints';
import { FetchRequestHandler } from '../../utils/commonUtilities';

export const fetchMyPractices = createAsyncThunk(
    'fetchMyPractices', 
    async (userId) => {
        const response = await FetchRequestHandler(
            'get', 
            `${baseUrl}api/users/${userId}/practices`
        );
        return response.data;
    }
);

